




































import { Component, Vue } from 'vue-property-decorator'
import {
  BatchPreviewRefundPostProcessCorrection,
  BatchApplyRefundPostProcessCorrection,
} from '@/api'
import { OrderStatusFormat } from '@/utils/tyepconvert'
import { Message, MessageBox } from 'element-ui'

@Component
export default class RefundPostProcessCorrectionBatchDialog extends Vue {
  private visible = false
  private loading = false
  private submitting = false
  private preview: any = null
  private orderCodes: string[] = []

  public async open(orderCodes: string[]) {
    const codes = Array.from(new Set((orderCodes || []).filter(Boolean)))
    if (codes.length <= 0) {
      Message.warning('请先勾选订单')
      return
    }
    this.orderCodes = codes
    this.visible = true
    this.preview = null
    this.loading = true
    try {
      this.preview = await BatchPreviewRefundPostProcessCorrection({ orderCodes: codes })
      if (this.preview.correctableCount <= 0) {
        Message.warning('所选订单均不可补正，请查看说明列')
      }
    } finally {
      this.loading = false
    }
  }

  private fenToYuan(fen: number) {
    if (fen == null) {
      return '0.00'
    }
    return (fen / 100).toFixed(2)
  }

  private statusLabel(code: number) {
    return code != null ? OrderStatusFormat(code) : '-'
  }

  private async confirmHandle() {
    if (!this.preview || this.preview.correctableCount <= 0) {
      return
    }
    try {
      await MessageBox.confirm(
        `确认对 ${this.preview.correctableCount} 个可补正订单执行批量补正？不可补正的 ${this.preview.uncorrectableCount} 单将跳过。此操作不会再次退款。`,
        '确认批量补正',
        { type: 'warning' }
      )
    } catch {
      return
    }
    this.submitting = true
    try {
      const res = await BatchApplyRefundPostProcessCorrection({ orderCodes: this.orderCodes })
      const ok = res && res.successCount != null ? res.successCount : 0
      const fail = res && res.failCount != null ? res.failCount : 0
      if (fail > 0) {
        Message.warning(`批量补正完成：成功 ${ok} 单，失败 ${fail} 单`)
      } else {
        Message.success(`批量补正完成：成功 ${ok} 单`)
      }
      this.visible = false
      this.$emit('done')
    } finally {
      this.submitting = false
    }
  }

  private onClose() {
    this.preview = null
    this.orderCodes = []
  }
}
